import { Box, Flex, Image, Typography } from "@jewlr/storybook/core"
import { Link } from "react-router-dom"
import styled from "styled-components"

import { SectionList } from "@jewlr/storybook/info"
import Button from "components/ui/button"
import { jewlr_t, IS_GE_CHECKOUT, IS_NA } from "helpers/application"
import { showHolidayRma, holidayRmaDates } from "helpers/holiday"

const PageTitle = styled(Typography)`
  font-size: 32px;
  font-weight: 700;
  line-height: 36px;
  margin-bottom: 32px;
  margin-top: 16px;
`

const ReturnText = styled(Typography).attrs((props) => ({
  textAlign: "left",
  ...props,
}))`
  font-size: 16px;
  font-weight: 300;
  letter-spacing: -0.02em;
  line-height: 22px;

  a {
    color: ${(props) => props.theme.colors.black};
    font-weight: 500;
    text-decoration: underline;
  }
`

const SectionTitle = styled(Typography).attrs((props) => ({
  fontSize: { _: "20px", tablet: "26px" },
  fontWeight: "500",
  lineHeight: { _: "20px", tablet: "30px" },
  ...props,
}))``

const ReturnList = styled(SectionList)`
  color: ${(props) => props.theme.colors.black};
  font-size: 16px;
  font-weight: 300;
  letter-spacing: -0.02em;
  line-height: 22px;
  margin-bottom: 32px;
`

const HolidayRmaBox = styled(Box)`
  background-color: white;
  border: 1px solid red;
  border-radius: 15px;
  font-weight: 400;
  letter-spacing: -0.02em;
  line-height: 22px;
  margin: 0 0 24px 0;
  padding: 24px 32px;

  ${(props) => props.theme.mediaQueries.tablet`
    margin:0 45px 48px 45px;
  `}
`
const FormContainer = styled(Box).attrs((props) => ({
  bg: props.theme.colors.grey[4],
  pb: { _: 1, tablet: 5 },
  pt: 8,
  ...props.theme.order.formContainerock,
}))``

const FormInnerBox = styled(Box).attrs((props) => ({
  contain: true,
  mx: { _: 2, tablet: "auto" },
  ...props.theme.order.formInnerBox,
}))``

const FormBlock = styled(Box).attrs((props) => ({
  p: { _: "32px 28px 28px 28px", tablet: "55px 32px 60px 32px" },
  ...props,
  ...props.theme.order.formBlock,
}))`
  align-items: center;
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 0 24px 0px;
  text-align: center;

  ${(props) => props.theme.mediaQueries.tablet`
    flex: 1 1 40%;
    margin: 0 24px 48px 24px;
  `}
`

const BlockIcon = styled(Image)`
  margin-bottom: 16px;
  width: 40px;
`

const FormTitle = styled(Typography)`
  font-size: 20px;
  font-weight: 700;
  line-height: 20px;
  margin-bottom: 24px;
`

const FaqContainer = styled(Box).attrs((props) => ({
  contain: true,
  mx: { _: 2, tablet: "auto" },
  pb: { _: 1, tablet: "147px" },
  pt: { _: "36px", tablet: "152px" },
  textAlign: { tablet: "center" },
  ...props.theme.order.faqContainer,
}))``

const FaqBlock = styled(Box).attrs((props) => ({
  as: Link,
  bg: props.theme.colors.grey[10],
  mb: { _: 2, tablet: 0 },
  p: { _: "33px 0", tablet: "60px 0 90px 0" },
  ...props,
  ...props.theme.order.faqBlock,
}))`
  align-items: center;
  display: flex;
  justify-content: center;

  ${(props) => props.theme.mediaQueries.tablet`
    display: block;
    flex: 1 1 30%;
    margin-right: 26px;

    :last-child {
      margin-right: 0;
    }
  `}
`

const FaqIcon = styled(Image)`
  margin-right: 6px;
  width: 32px;
  ${(props) => props.theme.mediaQueries.tablet`
    margin-right: 0;
    margin-bottom: 60px;
    width: 48px;
  `}
`

const FaqTitle = styled(Typography).attrs({
  fontSize: { _: "18px", tablet: "26px" },
})`
  font-weight: 500;
  line-height: 30px;
`

const ButtonLink = (props) => (
  <Button
    asChild
    className="text-18 font-medium"
    variant="secondary"
    {...props}
  />
)

const ReturnPolicy = () => {
  const is_na = IS_NA()
  const is_ge_checkout = IS_GE_CHECKOUT()

  return (
    <Box mb={7}>
      <Box contain mb={{ _: 8, tablet: "130px" }} mx={{ _: 2, tablet: "auto" }}>
        <PageTitle>Returns & Orders</PageTitle>
        {is_ge_checkout ? (
          <>
            <SectionTitle mb={2}>30-Day Return Policy</SectionTitle>
            <ReturnText>
              JEWLR offers a 30-day return policy. You may return an item for a
              refund (minus Deductions) within 30 days of the original{" "}
              {jewlr_t("terms.shipping")} date if the following conditions are
              met.
            </ReturnText>
            <ReturnList>
              <li>
                The item must be returned in a new and unworn condition. New and
                unworn condition means that there are no scratches, marks, or
                blemishes on the items. Items modified or re-sized are not
                considered new.
              </li>
              <li>
                The item must be postmarked within 30 days of the original
                shipment date.
              </li>
              <li>
                Items that have been resized, updated and/or repaired do not
                qualify for a refund.
              </li>
              <li>
                You are responsible for the return {jewlr_t("terms.shipping")}{" "}
                cost and the goods are your responsibility until they reach our
                warehouse.
              </li>
              <li>
                Luxury Bridal Collection items must be shipped to{" "}
                {sl.config.site_title} using Jewlr’s {jewlr_t("terms.shipping")}{" "}
                provider.
              </li>
              <li>
                Promotional gifts must also be returned with your returned item.
              </li>
              <li>
                Your Luxury Bridal Collection diamond report must be returned
                with your One and Only Signature Collection item. $150 will be
                deducted from the Refund for missing or damaged reports.
              </li>
              <li>
                Returns without a JEWLR Return Merchandise Authorization will be
                refused upon receipt.
              </li>
              <li>
                Pendants purchased as a donation to any charitable{" "}
                {jewlr_t("terms.organization")} are not eligible for a refund -
                including, but not limited to, My Everyday Hero pendants.
              </li>
              <li>
                Non-{jewlr_t("terms.jewelry")} and final sale items such as
                {jewlr_t("terms.Jewelry")} Cleaner and{" "}
                {jewlr_t("terms.Jewelry")} Care Cloths are not eligible for a
                refund.
              </li>
              <li>
                Returns with missing paperwork or product will not be processed.
              </li>
            </ReturnList>
            <ReturnText>
              NOTE: Some special orders are non-returnable. We will inform you
              if an item cannot be returned before going ahead with your order.
            </ReturnText>
          </>
        ) : (
          <>
            <SectionTitle mb={2}>99-Day Return Policy</SectionTitle>
            <ReturnText>
              We want you to feel comfortable and confident when shopping at{" "}
              {sl.config.site_title}. That is why we offer an easy, hassle-free
              99-day return policy. If you are not completely satisfied with
              your purchase you may return it for a full refund (minus any{" "}
              {jewlr_t("terms.shipping")} and/or gift packaging charges, if any)
              within 99 days of the original {jewlr_t("terms.shipping")} date.
              Upon receipt of your return, items are inspected for signs of wear
              or damage. If accepted, refunds will be issued to the original
              form of payment.
            </ReturnText>
            <ReturnList>
              <li>
                Any item purchased from {sl.config.site_title} can be returned,
                including engraved items
              </li>
              <li>
                The item(s) must be returned in a new and unworn condition
              </li>
              <li>
                Any promotional gifts must also be returned with your returned
                item
              </li>
              <li>
                Items which have been resized, updated and/or repaired do not
                qualify
              </li>
              <li>
                You will be responsible for the return{" "}
                {jewlr_t("terms.shipping")} cost
              </li>
            </ReturnList>
          </>
        )}
      </Box>
      <FormContainer>
        <FormInnerBox>
          <Typography
            fontSize="26px"
            fontWeight="500"
            lineHeight="30px"
            mb={6}
            textAlign="center"
          >
            Request Forms
          </Typography>
          <ReturnText mb={3} mx={{ tablet: "18%" }} textAlign="center">
            Need to make a return or change your order? Use the request forms
            below to get started. For further assistance, please contact
            customer service at{" "}
            <a
              className="nowrap"
              href={`mailto:${sl.config.customer_service_email}`}
              id="customer_service_email"
              rel="noreferrer"
              target="_blank"
            >
              {sl.config.customer_service_email}
            </a>{" "}
            or{" "}
            <a
              className="nowrap"
              href={`tel:${sl.config.customer_service_toll_free}`}
              rel="nofollow"
            >
              {sl.config.customer_service_toll_free}
            </a>
            .
          </ReturnText>
          {showHolidayRma() && (
            <HolidayRmaBox>
              In order to focus on customer orders and ensure all gifts arrive
              for the holidays, we will not be processing repairs between{" "}
              {holidayRmaDates.start} and {holidayRmaDates.end}. Don&apos;t
              worry &ndash; you&apos;re still covered! We will adjust or extend
              your repair deadline accordingly. Thank you for your understanding
              and cooperation during this busy time.
            </HolidayRmaBox>
          )}
          <Box
            display={{ tablet: "flex" }}
            flexWrap={{ tablet: "wrap" }}
            px={{ tablet: "21px" }}
          >
            <FormBlock>
              <BlockIcon
                alt="return"
                height="40px"
                src={require("images/icons/orders/return.svg")}
                width="40px"
              />
              <FormTitle>Request to Return</FormTitle>
              <ReturnText mb={3}>
                Complete this form to return an item you have purchased from{" "}
                {sl.config.site_title} for a refund.
              </ReturnText>
              <ReturnText mb={3}>
                To be eligible for a refund, your item(s) must be in a new and
                unworn condition and be within {is_ge_checkout ? "30" : "99"}{" "}
                days of the original {jewlr_t("terms.shipping")} date.
              </ReturnText>
              {is_ge_checkout ? (
                <>
                  <ButtonLink>
                    <a
                      data-lc="return-policy"
                      href="https://web.global-e.com/returns/portal/mZfW"
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      Return Request Form
                    </a>
                  </ButtonLink>
                  <p className="body-sm mt-32 text-left font-semibold">
                    If your order was placed prior to November 10, 2025, please{" "}
                    <Button asChild text underline>
                      <Link data-lc="return-policy" to="/order/return">
                        click here
                      </Link>
                    </Button>{" "}
                    to complete this form.
                  </p>
                </>
              ) : (
                <ButtonLink>
                  <Link data-lc="return-policy" to="/order/return">
                    Return Request Form
                  </Link>
                </ButtonLink>
              )}
            </FormBlock>
            {!is_ge_checkout && (
              <FormBlock flex="1 1 50%">
                <BlockIcon
                  alt="repair"
                  height="40px"
                  src={require("images/icons/orders/repair.svg")}
                  width="40px"
                />
                <FormTitle>Request to Repair</FormTitle>
                <ReturnText mb={3}>
                  Complete this form to submit a request to repair an item
                  purchased from {sl.config.site_title}.
                </ReturnText>
                <ReturnText mb={3}>
                  All {jewlr_t("terms.jewelry")}{" "}
                  {sl.config.enable_watches ? "and watches " : ""}include a FREE
                  1-year manufacturer&apos;s warranty. We also offer repair
                  services beyond the warranty period at an additional cost. For
                  more information, please{" "}
                  <Typography
                    as={Link}
                    className="nowrap"
                    color="black"
                    data-lc="return-policy"
                    to="/info/warranty-information"
                  >
                    click here
                  </Typography>
                  .
                </ReturnText>
                <ButtonLink>
                  <Link data-lc="return-policy" to="/order/repair">
                    Repair Request Form
                  </Link>
                </ButtonLink>
              </FormBlock>
            )}
            {!is_ge_checkout && (
              <FormBlock flex="1 1 50%">
                <BlockIcon
                  alt="resize"
                  height="40px"
                  src={require("images/icons/orders/resize.svg")}
                  width="40px"
                />
                <FormTitle>Request to Resize</FormTitle>
                <ReturnText mb={3}>
                  Complete this form to submit a request to resize a ring
                  purchased from {sl.config.site_title}.
                </ReturnText>
                <ReturnText mb={3}>
                  {is_na
                    ? "We offer one FREE resizing within two full sizes of your ring within 30 days of the original shipment date, including engraved items."
                    : "We offer ring resizing for a reasonable fee within 30 days of the original shipment date. This includes items that have engravings."}{" "}
                  To determine your correct ring size or for more information,
                  please{" "}
                  <Typography
                    as={Link}
                    className="nowrap"
                    color="black"
                    data-lc="return-policy"
                    to="/info/ring_sizing"
                  >
                    click here
                  </Typography>
                  .
                </ReturnText>
                <ButtonLink>
                  <Link data-lc="return-policy" to="/order/resizing">
                    Resize Request Form
                  </Link>
                </ButtonLink>
              </FormBlock>
            )}
            {!is_ge_checkout && (
              <FormBlock flex="1 1 50%">
                <BlockIcon
                  alt="change order"
                  height="40px"
                  src={require("images/icons/orders/change-order.svg")}
                  width="40px"
                />
                <FormTitle>Request to Change Order</FormTitle>
                <ReturnText mb={3}>
                  Complete this form to make a change or adjustment to a current{" "}
                  {sl.config.site_title} order in progress.
                </ReturnText>
                <ReturnText mb={3}>
                  To be eligible to make an order change depends on where in the
                  manufacturing process your order is when you make the request.
                  Please note that any change may also delay your estimated
                  shipment date.
                </ReturnText>
                <ButtonLink>
                  <Link data-lc="return-policy" to="/order/change">
                    Order Change Request Form
                  </Link>
                </ButtonLink>
              </FormBlock>
            )}
          </Box>
        </FormInnerBox>
      </FormContainer>
      <FaqContainer>
        <Typography
          fontSize="26px"
          fontWeight="400"
          lineHeight="30px"
          mb={{ _: "36px", tablet: "60px" }}
        >
          Frequently Asked Questions
        </Typography>
        <Flex
          flexDirection={{ _: "column", tablet: "row" }}
          flexWrap={{ tablet: "wrap" }}
        >
          <FaqBlock
            data-lc="return-policy"
            to="/helpdesk/5e9f51622c7d3a7e9aeb5bfc"
          >
            <FaqIcon
              alt="general question"
              height={{ _: "32px", tablet: "48px" }}
              src={require("images/helpdesk/general-questions.svg")}
              width={{ _: "32px", desktop: "48px" }}
            />
            <FaqTitle>General Questions</FaqTitle>
          </FaqBlock>
          <FaqBlock
            data-lc="return-policy"
            to="/helpdesk/5e9f516d2c7d3a7e9aeb5bfe"
          >
            <FaqIcon
              alt="order information"
              height={{ _: "32px", tablet: "48px" }}
              src={require("images/helpdesk/order-information.svg")}
              width={{ _: "32px", desktop: "48px" }}
            />
            <FaqTitle>Order Information</FaqTitle>
          </FaqBlock>
          <FaqBlock
            data-lc="return-policy"
            to="/helpdesk/5e9f517e04286364bc98bf37"
          >
            <FaqIcon
              alt="education"
              height={{ _: "32px", tablet: "48px" }}
              src={require("images/helpdesk/jewelry-education.svg")}
              width={{ _: "32px", desktop: "48px" }}
            />
            <FaqTitle>Jewelry Education</FaqTitle>
          </FaqBlock>
        </Flex>
      </FaqContainer>
    </Box>
  )
}

export default ReturnPolicy
